<template>
    <div class="rewardCheckoutSection" v-if="offers">
        <div class="mediaHideOnDesctop">
            <div class="pointsBox">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            Available reward points <span class="h2">{{ availablePoints }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="rewardsBOx">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="mediaHideOnDesctop">
                            <div class="titleBOx" @click="showRewards = !showRewards">
                                <h4>Apply your rewards</h4>
                                <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg" :class="{active: showRewards}">
                                    <path d="M1.41 0.839996L6 5.42L10.59 0.839996L12 2.25L6 8.25L0 2.25L1.41 0.839996Z" fill="#FEE27D"/>
                                </svg>
                            </div>
                        </div>
                        <div class="descktopMediaBox">
                            <div class="h2">
                                Apply your rewards
                            </div>
                        </div>
                        <VueSlickCarousel
                            class="rewardsList"
                            v-bind="settings"
                            v-show="showRewards"
                        >
                            <div class="el"
                                 v-for="offer in offers"
                                 :class="{active: (activeList.indexOf(offer.offer_id) !== -1)}"
                                 @click="setReward(offer)"
                            >
                                <div class="frame" :style="{backgroundImage: `url(${offer.offer_photo})`}">
                                </div>
                                <div class="title h2">
                                    {{ offer.offer_title.replace(/<[^>]*>?/gm, ' ')}}
                                </div>
                                <div class="points caption" v-if="offer.purchase_amount">
                                    <span>{{offer.purchase_amount}}</span> points
                                </div>
                                <div class="action">
                                    <div>Apply Reward</div>
                                </div>
                            </div>
                        </VueSlickCarousel>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import VueSlickCarousel from 'vue-slick-carousel'

    export default {
        name: "RewardSection",
        components: {VueSlickCarousel},
        data() {
            return {
                offers: null,
                availablePoints: null,
                //slick: null,
                activeList: [],
                showRewards: false,
                settings: {
                    arrows: false,
                    dots: false,
                    slidesToShow: 3,
                    slidesToScroll: 2,
                    infinite: false,
                    "responsive": [
                        {
                            "breakpoint": 1024,
                            "settings": {
                                "slidesToShow": 2.3,
                                "slidesToScroll": 2,
                                "infinite": false,
                                "dots": false
                            }
                        }
                    ]
                },
            }
        },
        created() {
            if (this.cart.coupon) {
                this.cart.coupon.map(c => {
                    this.activeList.push(c.offer_id);
                });
            }
            this.$store.dispatch("cart/getUserLoyaltyProfile", {
                callback: (res) => {
                    //console.log(res.data);
                    this.offers = res.data.offers.filter(el => el.redeemable);
                    this.availablePoints = res.data.available_points;
                    
                }
            });
            this.$store.dispatch('cart/loadTax',{
                callback: () => {
                    if(this.$store.state.cart.homeOffer){
                        let offer = this.$store.state.cart.homeOffer.offer;
                        if(this.activeList.indexOf(offer.offer_id) === -1){
                            this.setReward(offer)
                        }
                    }
                }
            });
            
        },
        computed: {
            cart() {
                return this.$store.state.cart.cart;
            }
        },
        methods: {
          setReward(offer){
              //console.log(offer);
              let points = this.availablePoints;
              this.$store.dispatch('cart/setCoupon', {offer, points});
              this.$store.dispatch('cart/loadTax',{callback: () => {}});
          }
        },
        watch: {
            "cart.coupon": function (val) {
                this.activeList = [];
                if (val) {
                    val.map(c => {
                        this.activeList.push(c.offer_id);
                    });
                }
            }
        }
    }
</script>
